/* eslint-disable */
import axios from "axios";

export default class Pricehelper {
  constructor(apiBaseUrl) {
    this.apiBaseUrl = apiBaseUrl;
    this.getPricesForSkus = this.getPricesForSkus.bind(this);
    this.getPriceHelperOverridePrice =
      this.getPriceHelperOverridePrice.bind(this);
  }

  getPriceHelperOverridePrice(articles) {
    const noppePriceUrl = `${this.apiBaseUrl}/api/v1/pricehelper`;
    const body = { articles: articles };
    const headers = {
      "Content-Type": "application/json",
    };

    return axios
      .post(noppePriceUrl, body, { headers })
      .then(response => {
        return response.data;
      })
      .catch(() => {
        console.error(
          "Error fetching price helper data",
          JSON.stringify(response)
        );
      });
  }

  getPricesForSkus(callBack, skuList) {
    var t0 = performance.now();
    let noppePriceUrl = `${this.apiBaseUrl}/api/v1/pricehelper`;
    let res = JSON.parse("{}");
    const priceSkus = skuList.map(sku => ({
      sku: sku.SKU,
      qty: sku.qty,
    }));
    const headers = {
      "Content-Type": "application/json",
    };

    axios
      .post(noppePriceUrl, { articles: priceSkus }, { headers })
      .then(response => {
        const result = response.data;
        res = result;
        var t1 = performance.now();
        res.comStatus = response.status;
        res.comMessage = "OK";
        res.comExecTime = t1 - t0;
        callBack(res);
      })
      .catch(error => {
        console.error(`error${error}`);
        callBack(res);
      });
  }

  /* OLD DEPRECATED */
  getPricesForSku(callBack, skuList) {
    var t0 = performance.now();
    let noppePriceUrl = `${this.apiBaseUrl}/api/v1/articleinfolist`;
    let res = JSON.parse("{}");
    const priceSkus = skuList.map(sku => ({
      sku: sku.sku,
      qty: sku.qty,
    }));
    const headers = {
      "Content-Type": "application/json",
    };

    axios
      .post(noppePriceUrl, priceSkus, { headers })
      .then(response => {
        res = processResult(response.data);
        var t1 = performance.now();
        res.comStatus = response.status;
        res.comMessage = "OK";
        res.comExecTime = t1 - t0;
        callBack(res);
      })
      .catch(error => {
        res.comStatus = error.response.status;
        res.comMessage = "Error rest service";
        res.comExecTime = 0;
        console.error(`error${error.response}`);
        callBack(res);
      });
  }
}

function formatSkusForNoppe(json) {
  let rval = new Array();
  json.forEach(function (skuIn) {
    let sku = new Array();
    sku.push('{"Sku":' + '"' + skuIn + '"' + "}");
    rval.push(sku);
  });

  return JSON.parse("[" + rval + "]");
}
